<div class="theme-wrapper">
    <app-toolbar></app-toolbar>
    <app-content></app-content>
</div>
